<template>
    <div class="header">
        <img class="brand-logo" v-bind:src="logoSrc" />
        <h2 class="model-text">{{ locale(modelText) }}</h2>
    </div>
</template>

<style scoped>
.header {
    padding-top: 20px;
}

.brand-logo {
    height: 34px;
    margin-top: 3vh;
}

.model-text {
    font-size: 30px;
    font-weight: normal;
    letter-spacing: -0.4px;
    line-height: 44px;
    margin: 3vh 0px 0px 0px;
}

@media screen and (max-height: 1340px) {

    .brand-logo {
        margin-top: 0vh;
    }

    .model-text {
        font-size: 20px;
        margin-top: 0vh;
    }
}
</style>

<script>
export const header = {
    props: {
        logo: {
            type: String,
            default: null
        }
    },
    computed: {
        modelText() {
            return this.description;
        },
        logoSrc() {
            return this.logo
                ? this.logo
                : "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
        }
    }
};

export default header;
</script>
